namespace GeniuzPOS.Purchase {
    export interface ReportPendingPRForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        SupplierId: Serenity.LookupEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        ShipId: Serenity.StringEditor;
        ShipDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        DtList: ReportPendingPRDtEditor;
        Remark: Serenity.StringEditor;
        PurOrderAmt: Serenity.DecimalEditor;
        PayTermCode: Serenity.StringEditor;
    }

    export class ReportPendingPRForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ReportPendingPR';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportPendingPRForm.init)  {
                ReportPendingPRForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = ReportPendingPRDtEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(ReportPendingPRForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'SupplierId', w2,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'ShipId', w0,
                    'ShipDate', w1,
                    'WhsId', w0,
                    'DtList', w3,
                    'Remark', w0,
                    'PurOrderAmt', w4,
                    'PayTermCode', w0
                ]);
            }
        }
    }
}
